import request from '@/utils/request'
import { BASE_API } from '@/api/baseUrl'

/**
 * 物流异常单
 * 查询全部
 * @param {*} params
 */
export function apiListAbnormalLogistic(data) {
  return request({
    url: BASE_API() + '/abnormallogistic/listAbnormalLogistic',
    method: 'post',
    data
  })
}

/**
 * 物流异常单
 * 分页查询
 * @param {*} params
 */
export function apiQueryAbnormalLogistic(data) {
  return request({
    url: BASE_API() + '/wantGoodsDataQuery/queryAbnormalLogistic',
    // url: BASE_API() + '/abnormallogistic/queryAbnormalLogistic',
    method: 'post',
    data
  })
}

/**
 * 物流异常单
 * 新增保存
 * @param {*} params
 */
export function apiSaveAbnormalLogistic(data) {
  return request({
    url: BASE_API() + '/abnormallogistic/saveAbnormalLogistic',
    method: 'post',
    data
  })
}

/**
 * 物流异常单
 * 推送安吉
 * @param {*} params
 */
export function apiSendAbnormalLogistic(data) {
  return request({
    url: BASE_API() + '/abnormallogistic/sendAbnormalDataToAnji',
    method: 'post',
    data
  })
}

/**
 * 物流异常单
 * 根据id查询详情
 * @param {*} params
 */
export function apiAbnormallogisticFindById(params) {
  return request({
    url: BASE_API() + '/abnormallogistic/findById',
    method: 'get',
    params
  })
}

/**
 * 物流异常单
 * 分页查询发货单明细
 * @param data
 */
export function apiQueryAbnormalLogisticDeliver(data) {
  return request({
    url: BASE_API() + '/abnormallogistic/queryAbnormalLogisticDeliver',
    method: 'post',
    data
  })
}

/**
* 关闭物流异常单
*
* @param {*} params
*/
export function apiCloseAbnormalByIds(data) {
  return request({
    url: BASE_API() + '/abnormallogistic/closeByIds',
    method: 'post',
    data
  })
}

/**
 * 物流配送时效查询
 * * 分页查询
 * @param {*} params
 */
export function apiQueryLogisticsShipLimit(data) {
  return request({
    url: BASE_API() + '/logistics/findWarehouseShipLimit',
    method: 'post',
    data
  })
}

/**
 * 分仓时效查询
 * * 分页查询
 * @param {*} params
 */
export function apiLogisticSagingFindList(data) {
  return request({
    url: BASE_API() + '/logisticSaging/findList',
    method: 'post',
    data
  })
}

/**
 * 分仓时效保存
 * * 分页查询
 * @param {*} params
 */
export function apiLogisticSagingUpdate(data) {
  return request({
    url: BASE_API() + '/logisticSaging/updateTransStd',
    method: 'post',
    data
  })
}

/**
 * 分仓时效详情查询
 * @param {*} params
 */
export function apiLogisticSagingFindById(data) {
  return request({
    url: BASE_API() + '/logisticSaging/findById',
    method: 'post',
    data
  })
}

/**
 * 发货运费设置（单价距离）
 * @param {*} params
 */
export function apiLogisticSagingSaveDistancePrices(data) {
  return request({
    url: BASE_API() + '/logisticSaging/saveDistancePrices',
    method: 'post',
    data
  })
}

/**
 * 发货运费设置（干线运输）
 * @param {*} params
 */
export function apiLogisticSagingSaveMainLinePrices(data) {
  return request({
    url: BASE_API() + '/logisticSaging/saveMainLinePrices',
    method: 'post',
    data
  })
}

/**
 * 发货对账查询
 * @param {*} params
 */
export function apiDeliveryCheckQuery(data) {
  return request({
    // url: BASE_API() + '/reconciliation/findDeliveryCheckoutList',
    url: BASE_API() + '/wantGoodsDataQuery/findDeliveryCheckoutList',
    method: 'post',
    data
  })
}

/**
 * 发货对账明细列表
 * @param {*} params
 */
export function apiFindCheckBillNoDetails(data) {
  return request({
    url: BASE_API() + '/reconciliation/findCheckBillNoDetails',
    method: 'post',
    data
  })
}

/**
 * 发货对账生成查询
 * @param {*} params
 */
export function apiFindDeliveryCheckoutGenerate(data) {
  return request({
    url: BASE_API() + '/reconciliation/findDeliveryCheckoutGenerate',
    method: 'post',
    data
  })
}

/**
 * 确认对账
 * @param {*} params
 */
export function apiAddReconciliation(data) {
  return request({
    url: BASE_API() + '/reconciliation/addReconciliation',
    method: 'post',
    data
  })
}

/**
 * 运费结算查询
 * @param {*} params
 */
export function apiFindDeliverySettlement(data) {
  return request({
    // url: BASE_API() + '/deliverysettlement/findDeliverySettlement',
    url: BASE_API() + '/wantGoodsDataQuery/findDeliverySettlement',
    method: 'post',
    data
  })
}

/**
 * 运费结算明细列表
 * @param {*} params
 */
export function apiFindDeliverySettlementDetails(data) {
  return request({
    url: BASE_API() + '/deliverysettlement/findDeliverySettlementDetails',
    method: 'post',
    data
  })
}

/**
 * 运费结算生成
 * @param {*} params
 */
export function apiFindDeliverySettlementGeneration(data) {
  return request({
    url: BASE_API() + '/deliverysettlement/findDeliverySettlementGeneration',
    method: 'post',
    data
  })
}

/**
 * 运费结算生成
 * @param {*} params
 */
export function apiAddDeliverySettlementGeneration(data) {
  return request({
    url: BASE_API() + '/deliverysettlement/addDeliverySettlementGeneration',
    method: 'post',
    data
  })
}

/**
 * 发货订单查询
 * @param {*} params
 */
export function apiDeliveryorderquery(data) {
  return request({
    url: BASE_API() + '/deliveryorderquery/findAll',
    method: 'post',
    data
  })
}

/**
 * 发货订单查询导出
 * @param {*} params
 */
export function apiDeliveryorderqueryExcelExport(data) {
  return request({
    url: BASE_API() + '/deliveryorderquery/findAllExportExcel',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/applyForGoods/logisticsAbnormal.js